<template>
  <div class="flex h-full flex-grow flex-col items-center justify-center">
    <div class="bg-gradient-green flex h-14 w-14 items-center justify-center rounded-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="h-8 w-8 text-white">
        <path
          pathLength="1"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="1"
          d="M4.5 12.75l6 6 9-13.5"
          class="invisible fill-transparent"
          style="stroke-dashoffset: 0; visibility: visible" />
      </svg>
    </div>
    <h3 class="mt-6 text-center text-2xl lg:text-5xl">
      {{ $t('form.success.title') }}
    </h3>
    <FormButton
      type="button"
      :label="$t('form.success.cta')"
      class="mx-auto mt-8 w-auto"
      :state="FormState.SUCCESS"
      @click="setFormVariant(formVariant)" />
  </div>
</template>

<script setup lang="ts">
  import { FormState } from '~/constants/form'

  const { formVariant, setFormVariant } = useFormVariant()
</script>
